import TextBox from "../component/ConfigurationComponent/TextBox";
import Password from "../component/ConfigurationComponent/Password";
import TextArea from "../component/ConfigurationComponent/TextArea";
import SingleSelect from "../component/ConfigurationComponent/SingleSelect";
import MultiSelect from "../component/ConfigurationComponent/MultiSelect";
import File from "../component/ConfigurationComponent/File";
import Date from "../component/ConfigurationComponent/Date";
import DateTime from "../component/ConfigurationComponent/DateTime";
import Time from "../component/ConfigurationComponent/Time";
import Number from "../component/ConfigurationComponent/Number";
import Decimal from "../component/ConfigurationComponent/Decimal";
import Default from "../component/ConfigurationComponent/Default";


export const CONFIG_COMPONENT_NAME = {
  ["Text Box"]: TextBox,
  ["Password"]: Password,
  ["Text Area"]: TextArea,
  ["Dropdown Single Select"]: SingleSelect,
  ["Dropdown Multiple Select"]: MultiSelect,
  ["File"]: File,
  ["Date Picker"]: Date,
  ["Time Picker"]: Time,
  ["Date Time Picker"]: DateTime,
  ["Json"]: TextArea,
  ["Number"]: Number,
  ["Decimal"]: Decimal,
  ["Default"]: Default,
};
